export const BADGE_COLORS = {
  red: 'bg-red-100 border-red-200 text-red-700',
  orange: 'bg-orange-100 border-orange-200 text-orange-700',
  amber: 'bg-amber-100 border-amber-200 text-amber-700',
  yellow: 'bg-yellow-100 border-yellow-200 text-yellow-700',
  lime: 'bg-lime-100 border-lime-200 text-lime-700',
  green: 'bg-green-100 border-green-200 text-green-700',
  emerald: 'bg-emerald-100 border-emerald-200 text-emerald-700',
  teal: 'bg-teal-100 border-teal-200 text-teal-700',
  cyan: 'bg-cyan-100 border-cyan-200 text-cyan-700',
  sky: 'bg-sky-100 border-sky-200 text-sky-700',
  blue: 'bg-blue-100 border-blue-200 text-blue-700',
  indigo: 'bg-indigo-100 border-indigo-200 text-indigo-700',
  violet: 'bg-violet-100 border-violet-200 text-violet-700',
  purple: 'bg-purple-100 border-purple-200 text-purple-700',
  fuchsia: 'bg-fuchsia-100 border-fuchsia-200 text-fuchsia-700',
  pink: 'bg-pink-100 border-pink-200 text-pink-700',
  rose: 'bg-rose-100 border-rose-200 text-rose-700',
  gray: 'bg-gray-100 border-gray-200 text-gray-700',
};

export const SWATCH_COLORS = {
  red: 'bg-red-400',
  orange: 'bg-orange-400',
  amber: 'bg-amber-400',
  yellow: 'bg-yellow-400',
  lime: 'bg-lime-400',
  green: 'bg-green-400',
  emerald: 'bg-emerald-400',
  teal: 'bg-teal-400',
  cyan: 'bg-cyan-400',
  sky: 'bg-sky-400',
  blue: 'bg-blue-400',
  indigo: 'bg-indigo-400',
  violet: 'bg-violet-400',
  purple: 'bg-purple-400',
  fuchsia: 'bg-fuchsia-400',
  pink: 'bg-pink-400',
  rose: 'bg-rose-400',
  gray: 'bg-gray-400',
};
